import React from "react"

//CSS
import {article} from "./article.module.css"
import {languageBar} from "./article.module.css"

import LanguageBar from "./languageBar"

const Article = props => {
    let articleMaxWidth = 1200;
    if (typeof props.articleMaxWidth !== "undefined") articleMaxWidth = props.articleMaxWidth;
    
    let articleBackGroundColor = "#ffffff";
    if (typeof props.articleBackGroundColor !== "undefined") articleBackGroundColor = props.articleBackGroundColor;

    let articleOverflow = "hidden";
    if (typeof props.articleOverflow !== "undefined") articleOverflow = props.articleOverflow;


    
    return (
        <div 
        className={article}
        style={{
            maxWidth: `${articleMaxWidth}px`,
            backgroundColor: `${articleBackGroundColor}`,
            overflow:`${articleOverflow}`
        }}
        >
            <div className={languageBar}>
                {props.isLangBar === "true" ? <LanguageBar
                    setLang={props.setLang}
                    lang={props.lang}
                /> : <></>}
            </div>
            {props.children}
        </div>
    )
}

export default Article;